import * as Sentry from '@sentry/react'

type Extras = Record<string, unknown>

export const handleFetchErrorFunctional =
  function handleFetchErrorFunctional() {
    return (error: Error, extra: Extras) => {
      console.error(error)
      Sentry.captureException(error, { extra })
    }
  }
